import { useTheme } from '../lib/styles';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { useCalendarProps } from '../internal/CalendarPropsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DayOfWeek({
  children,
  formattedDate,
  dayOfWeekNumber,
  weekDayKey
}) {
  const {
    uiAddonCalendars
  } = useTheme();
  const {
    use,
    compact
  } = useCalendarProps();
  const isFirstDayOfWeek = dayOfWeekNumber === 0;
  const isLastDayOfWeek = dayOfWeekNumber === uiAddonCalendars.weekDayNumber - 1;
  const inlineBorderStyles = {
    borderInlineStartWidth: '0',
    borderInlineEndWidth: '100'
  };
  if (isFirstDayOfWeek && use === 'WEEK') {
    inlineBorderStyles.borderInlineStartWidth = '100';
  }
  if (isLastDayOfWeek && use === 'MONTH') {
    inlineBorderStyles.borderInlineEndWidth = '0';
  }
  if (compact) {
    inlineBorderStyles.borderInlineWidth = '0';
  }
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    "data-test-id": `day-of-week--${weekDayKey}`,
    alignItems: "center",
    justifyContent: "center",
    borderColor: "border-core-subtle",
    borderStyle: "solid",
    borderBlockWidth: "0",
    inlineSize: `${uiAddonCalendars.dayWidthPercent}%`
  }, inlineBorderStyles, {
    children: /*#__PURE__*/_jsx(Text, {
      "data-test-id": formattedDate ? `day-of-week-header-${formattedDate}` : undefined,
      marginBlockEnd: "0",
      as: "h6",
      textTransform: uiAddonCalendars.headerTextStyles.textTransform,
      color: uiAddonCalendars.headerTextStyles.color,
      children: children
    })
  }));
}